/**
 * The six colours, and the rule that there are six.
 *
 * `apps/iamboone.app/styles.css` has said *"do not introduce a seventh colour without a
 * reason"* since the marketing site was written, and until now that sentence was the whole
 * mechanism: three stylesheets each spelled the hexes out, and nothing compared them. They
 * happen to agree today. Nothing would have said so if they stopped.
 *
 * The names are the paint, never the job — a role reaches for one of these
 * ({@link BRAND_ROLES}) and the surfaces reach for the role. That indirection is what lets
 * `--brand` be forest in a light theme and sage in a dark one without either name lying.
 */
export const PALETTE = {
  forest: "#1e3a2e",
  navy: "#0d1b2a",
  copper: "#c56a2d",
  sage: "#a3b18a",
  sand: "#eadfc8",
  offWhite: "#f6f4ee",
} as const;

export type PaletteColour = keyof typeof PALETTE;
